import { render, staticRenderFns } from "./OrderModalNote.vue?vue&type=template&id=319b2ecc&scoped=true&"
import script from "./OrderModalNote.vue?vue&type=script&lang=js&"
export * from "./OrderModalNote.vue?vue&type=script&lang=js&"
import style0 from "./OrderModalNote.vue?vue&type=style&index=0&id=319b2ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b2ecc",
  null
  
)

export default component.exports